import { render, staticRenderFns } from "./DocumentImportComponent.vue?vue&type=template&id=95736bfa&scoped=true&"
import script from "./DocumentImportComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentImportComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentImportComponent.vue?vue&type=style&index=0&id=95736bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95736bfa",
  null
  
)

export default component.exports